module.exports = __webpack_public_path__ + "static/media/SDFSA_8-240w.51ab6980.jpg";